'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const Tokens = require('@zapier/design-tokens');

const _interopDefault = e => e && e.__esModule ? e : { default: e };

const Tokens__default = /*#__PURE__*/_interopDefault(Tokens);

const Typography = {
  // For use cases where styles are unique but the same
  // `fontFamily` should be used.
  base: {
    fontFamily: Tokens__default.default.Inter
  },
  heading: {
    fontFamily: Tokens__default.default.Degular
  },
  PageHeader: {
    font: Tokens__default.default.PageHeader,
    letterSpacing: Tokens__default.default.LetterSpacingHeader
  },
  SectionHeader: {
    font: Tokens__default.default.SectionHeader,
    letterSpacing: Tokens__default.default.LetterSpacingHeader
  },
  SectionHeaderMultiline: {
    font: Tokens__default.default.SectionHeaderMultiline,
    letterSpacing: Tokens__default.default.LetterSpacingHeader
  },
  ParagraphHeader4: {
    font: Tokens__default.default.ParagraphHeader4
  },
  ParagraphHeader3: {
    font: Tokens__default.default.ParagraphHeader3
  },
  ParagraphHeader2: {
    font: Tokens__default.default.ParagraphHeader2
  },
  ParagraphHeader1: {
    font: Tokens__default.default.ParagraphHeader1
  },
  Title: {
    font: Tokens__default.default.Title,
    letterSpacing: Tokens__default.default.LetterSpacingHeader
  },
  Body4: {
    font: Tokens__default.default.Body4
  },
  Body4Multiline: {
    font: Tokens__default.default.Body4Multiline
  },
  Body3: {
    font: Tokens__default.default.Body3
  },
  Body3Multiline: {
    font: Tokens__default.default.Body3Multiline
  },
  Body2: {
    font: Tokens__default.default.Body2
  },
  Body2Multiline: {
    font: Tokens__default.default.Body2Multiline
  },
  Body1: {
    font: Tokens__default.default.Body1
  },
  Body1Multiline: {
    font: Tokens__default.default.Body1Multiline
  },
  SmallPrint4: {
    font: Tokens__default.default.SmallPrint4
  },
  SmallPrint4Multiline: {
    font: Tokens__default.default.SmallPrint4Multiline
  },
  SmallPrint3: {
    font: Tokens__default.default.SmallPrint3
  },
  SmallPrint3Multiline: {
    font: Tokens__default.default.SmallPrint3Multiline
  },
  SmallPrint2: {
    font: Tokens__default.default.SmallPrint2
  },
  SmallPrint2Multiline: {
    font: Tokens__default.default.SmallPrint2Multiline
  },
  SmallPrint1: {
    font: Tokens__default.default.SmallPrint1
  },
  SmallPrint1Multiline: {
    font: Tokens__default.default.SmallPrint1Multiline
  },
  MinimalPrint4: {
    font: Tokens__default.default.MinimalPrint4
  },
  MinimalPrint4Multiline: {
    font: Tokens__default.default.MinimalPrint4Multiline
  },
  MinimalPrint3: {
    font: Tokens__default.default.MinimalPrint3
  },
  MinimalPrint3Multiline: {
    font: Tokens__default.default.MinimalPrint3Multiline
  },
  MinimalPrint2: {
    font: Tokens__default.default.MinimalPrint2
  },
  MinimalPrint2Multiline: {
    font: Tokens__default.default.MinimalPrint2Multiline
  },
  MinimalPrint1: {
    font: Tokens__default.default.MinimalPrint1
  },
  MinimalPrint1Multiline: {
    font: Tokens__default.default.MinimalPrint1Multiline
  }
};

exports.Typography = Typography;
//# sourceMappingURL=Typography.cjs.js.map
